<template lang="pug">
bottom-modal(:id="modalId", width="w-xtra-large", :loading="onLoading('batch-planogram')")
    span(slot="header-text") Batch Generate Shelf Label
    template
        div(slot="body")
            .container(v-if="isActive")
                .row
                    .col-md-3
                        filter-sidebar-planogram(
                            ref="planogramSidebar" 
                            :updateFilters="updateFilters",
                            :marginLeftChange="setMarginLeft",
                            :marginTopChange="setMarginTop",
                            :marginSelectionOptionChange="setMarginSelectionOption",
                            :dimensionChange="setDimension", 
                            :id="id",
                            )

                    .col-md-9
                        .alert.alert-info
                            v-loading(loader="fetch-planogram-product")
                                template(v-if="totalProductCount > 0")
                                    | {{ totalProductCount }} planograms match the filters
                                template(v-else)
                                    | No planogram under the applied filters

                        .md-form-group
                            label.md-check
                                input(
                                    v-model="addAllMatching"
                                    type="checkbox"
                                    @change="handleSelectAll"
                                    )
                                i.indigo 
                                | Add All Matching
                        
                        v-server-table(
                        :url="planogramUrl",
                        :columns="columns",
                        :options="tableOptions",
                        :name="tableName",
                        ref="datatable"
                        @loaded="onLoaded"
                        )
                            template(slot="select", slot-scope="props")
                                label.md-check
                                    input(
                                    type="checkbox",
                                    :checked="props.row.selected",
                                    v-model="selectedItems",
                                    :value="props.row")
                                    i.indigo

        button.btn.btn-fw.primary(slot="footer", @click="generate", :disabled="disable") 
            v-loading(loader="generate-planogram")
                | Generate
</template>
<script>
import download from './download-planogram';
import OverrideValuesForm from './batch/override-values-form';
import FilterSidebarPlanogram from '../pricebook/template/filter-sidebar-planogram';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';

export default {
    components: {
        OverrideValuesForm,
        FilterSidebarPlanogram,
    },

    mixins: [download],

    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isActive: false,
            dimension: null,
            leftMargin: '',
            topMargin: '',
            selectedOption: null,
            totalProductCount: 0,
            addAllMatching: false,
            disable: true,
            filters: {
                planograms: [],
                search: null,
            },
            selectedItems: [],
            tableName: 'BATCH_GENERATE_SHELF_LABEL',
            columns: [
                'select',
                'planogram_name',
                'product_code',
                'product_sequence',
                'product_facing',
                'product_name',
                'station_price',
            ],
        };
    },

    computed: {
        ...mapState('planogram', ['product_list', 'planogram_list']),

        ...mapActions('planogram', ['getProductList']),

        modalId() {
            return 'batch-planogram-popup';
        },
        planogramUrl() {
            return Laroute.route('franchise.inventory.planogram.product_list');
        },
        tableOptions() {
            return {
                filterable: false,
                sortable: [],
                headings: {
                    select: 'Select',
                    name: 'Planogram Name',
                    product_code: 'Barcode',
                    product_name: 'Description',
                    station_price: 'Station Price (RM)',
                    product_sequence: 'Sequence',
                    product_facing: 'Facing',
                },
                params: {
                    pricebook_id: this.id,
                    planogram_id: this.filters.planograms.map(a => a.id),
                    query: this.filters.search,
                },
                texts: {
                    noResults: 'Please select the planogram to generate',
                },
            };
        },
        propertyChanged() {
            return `${this.dimension}|
            ${this.addAllMatching}|
            ${this.selectedOption}|
            ${this.selectedItems}`;
        },
    },
    watch: {
        propertyChanged() {
            this.disable = this.disabledGenerate();
        },
    },
    mounted() {
        this.$on('show', () => {
            this.isActive = true;
            this.showModal();
        });
        this.toggleLoader({
            name: 'fetch-planogram-product',
            start: true,
        });
        $(`#${this.modalId}`).on('hide.bs.modal', () => {
            this.isActive = false;
            this.addAllMatching = false;
        });
    },
    methods: {
        ...mapMutations('planogram', ['setPlanogramList']),
        disabledGenerate() {
            if (
                this.dimension == '1' ||
                this.dimension == '2' ||
                this.dimension == '3'
            ) {
                if (
                    this.totalProductCount > 0 &&
                    this.selectedItems.length > 0
                ) {
                    return false;
                }
            } else if (this.dimension == '4' || this.dimension == '5')
                if (
                    this.totalProductCount > 0 &&
                    this.selectedItems.length > 0 &&
                    this.selectedOption !== null
                ) {
                    return false;
                }
            return true;
        },
        showModal() {
            $(`#${this.modalId}`).modal('show');
            this.reset();
        },
        hideModal() {
            $(`#${this.modalId}`).modal('hide');
        },
        updateFilters(filters) {
            this.toggleLoader({
                name: 'fetch-planogram-product',
                start: true,
            });
            this.filters = filters;
            this.refreshFilters();

            // update chosen planogram  into state
            this.setPlanogramList(this.filters.planograms);

            // update product data table response
            this.selectedAllProduct();
        },

        handleSelectAll() {
            if (this.addAllMatching) {
                this.selectedItems = this.product_list.data;
            } else {
                this.selectedItems = [];
            }
        },

        selectedAllProduct() {
            this.$store.dispatch('planogram/getProductList', {
                pricebook_id: this.id,
                planogram_id: this.filters.planograms.map(a => a.id),
            });
        },
        setDimension(dimension) {
            this.leftMargin = '';
            this.topMargin = '';
            this.dimension = dimension;
            this.selectedOption = null;
        },
        setMarginLeft(marginLeft) {
            this.marginLeft = marginLeft;
        },
        setMarginTop(marginTop) {
            this.marginTop = marginTop;
        },
        setMarginSelectionOption(selectedOption) {
            this.selectedOption = selectedOption;
        },
        onLoaded(response) {
            this.toggleLoader({
                name: 'fetch-planogram-product',
                start: false,
            });
            this.totalProductCount = response.data ? response.data.count : 0;
        },
        refreshFilters() {
            // Workaround because the params doesn't seems to be
            // updated when changed within the same event bus
            this.$nextTick(this.refreshListing);
        },
        refreshListing() {
            this.$refs.datatable.refresh();
        },
        async generate() {
            let params = {
                pricebook_id: this.id,
                query: this.filters.search,
                planogram_id: this.filters.planograms.map(a => a.id),
                dimension: this.dimension,
                product_id: this.selectedItems.map(p => p.product_id),
                planogram_product_id: this.selectedItems.map(p => p.pp_id),
                leftMargin: this.marginLeft,
                topMargin: this.marginTop,
                selectedOption: this.selectedOption,
            };
            const response = await this.generatePlanogram(params);
        },
        reset() {
            this.selectedItems = [];
            this.filters.planograms = [];
            this.filters.search = null;
            this.selectedOption = null;
            this.leftMargin = '';
            this.topMargin = '';
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/batch-generate-planogram.vue